var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",staticStyle:{"position":"relative","height":"100%"},attrs:{"id":"droparea"}},[_c('LightBox',{ref:"lightbox",attrs:{"id":"customlightboxtmp","media":_vm.media,"show-caption":true,"show-light-box":false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-feaff472","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lightbox/custom-lightbox.vue
// module id = 1031
// module chunks = 0